import React, { useState } from 'react';
import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../msreact-kit/html-components/button';
import { RegisterCompany } from '@mobilitystore/user-onboarding-interface';
import idConstants from '../../../data/idConstants';
import { getEnvironment } from '../../../utils';
import { getRegionCode } from '../../../utils/get-region-details';
import * as Constants from '../../../actions/configuration';
import SnackBar from '../../../components/Shared/Utils/SnackBar';
import './index.scss';

const CreateUser = ({ onCreate }) => {
  const [username, setUsername] = useState('');
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [snackBarFlag, setSnackBarFlag] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('');
  const [snackBarSeverity, setSnackBarSeverity] = useState('');
  const csmTenants = useSelector((state) => state.UserServiceReducer?.csmTenants);
  // Defensive: ensure token is present
  const clientToken = localStorage.getItem(idConstants.tokens.aaaIdToken);
  // Defensive: ensure regionCode is present
  const regionCode = getRegionCode ? getRegionCode() : '';
  // Defensive: environment
  const environment = getEnvironment
    ? getEnvironment(process.env.REACT_APP_ENVIRONMENT)
    : '';

  // If you need dynamicForm, set it here, e.g. from props or state
  // const dynamicForm = ...;

  const handleCreate = () => {
    setOpenRegisterModal(true);
  };
  const handleResponse = (response) => {
    // Refresh the user list if callback is provided
    if (onCreate) {
      onCreate();
    }
  };

  return (
    <div className='create-user'>
      <div className='create-user__content'>
        <div className='create-user__header'>
          <h6>{i18next.t('DYNAMIC_FORM.USER_MANAGEMENT.ADD_NEW_USER')}</h6>
          <p>{i18next.t('DYNAMIC_FORM.USER_MANAGEMENT.CREATE_USER_DESCRIPTION')}</p>
        </div>
        <PrimaryButton
          onClick={handleCreate}
          label=''
          className='create-user__button'
        >
          <span className='a-button__label'>
            {'+'}{' '}
            <span className='d-sm-none'>
              {i18next.t('DYNAMIC_FORM.USER_MANAGEMENT.CREATE_USER')}
            </span>
          </span>
        </PrimaryButton>
      </div>

      {openRegisterModal && clientToken && (
        <RegisterCompany
          language='en'
          clientToken={clientToken}
          environment={environment}
          successHandler={(response) => handleResponse(response)}
          closeHandler={() => {
            setOpenRegisterModal(false);
            // Refresh list on close after successful creation
            if (onCreate) {
              onCreate();
            }
          }}
          cancelHandler={() => {
            setOpenRegisterModal(false);
            if (onCreate) {
              onCreate();
            }
          }}
          isOnboardingByCsm={true}
          errorHandler={(error) => {
            if (error.message) {
              setSnackBarFlag(true);
              setSnackBarMsg(error.message);
              setSnackBarSeverity('error');
            }
          }}
          role={Constants.AAA_CONFIG.BUYER_ROLE}
          tenantId={csmTenants?.tenantId}
        />
      )}
      {snackBarFlag && snackBarMsg && (
        <SnackBar
          message={snackBarMsg}
          severity={snackBarSeverity}
          changeState={() => {
            setSnackBarFlag(false);
            setSnackBarMsg('');
            setSnackBarSeverity('');
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          from='codesnippet'
        />
      )}
    </div>
  );
};

export default CreateUser;
